export default __webpack_public_path__ + "images/logoAllure.1370f7b6bc40f00a8fddfa050a74c4c6.svg"